import MobileBottomNav from "components/v2/mobile-bottom-nav/MobileBottomNav";
import { useLoanCentricMobileDock } from "./useLoanCentricMobileDock";

/**
 * Loan-centric mobile bottom dock: Home | Loans | Settings.
 * Mount via GlobalNavigationShell `mobileNavSlot` when flag + phone.
 */
export default function LoanCentricMobileDock() {
  const { items, activeTab, onTabChange } = useLoanCentricMobileDock();

  return (
    <MobileBottomNav
      items={items}
      activeTab={activeTab}
      onTabChange={onTabChange}
      safeAreaInsetEnabled
    />
  );
}
